module.exports = __webpack_public_path__ + "img/background-dialogs.b26cfd02.jpg";